import { call, put, takeLatest } from "redux-saga/effects";
import { UNSUBSCRIBE_NEWSLETTER } from "../types/newsletter/unsubscribe";
import newsletter from "../../services/newsletter";

function* unsubscribeNewsletterSaga(action: any) {
  console.log('🔍 [Frontend Saga] unsubscribeNewsletterSaga - Iniciando...');
  console.log('📦 [Frontend Saga] unsubscribeNewsletterSaga - Action payload:', action.payload);

  try {
    console.log('📡 [Frontend Saga] unsubscribeNewsletterSaga - Llamando al servicio...');
    const { response, error } = yield call(newsletter.unsubscribe, action.payload);

    if (error) {
      console.error('❌ [Frontend Saga] unsubscribeNewsletterSaga - Error del servicio:', error);
      yield put({ type: `${UNSUBSCRIBE_NEWSLETTER}_ERROR`, payload: error.message });
    } else {
      console.log('✅ [Frontend Saga] unsubscribeNewsletterSaga - Respuesta exitosa:', response);
      yield put({ type: `${UNSUBSCRIBE_NEWSLETTER}_SUCCESS`, payload: response });
    }
  } catch (error: any) {
    console.error('❌ [Frontend Saga] unsubscribeNewsletterSaga - Error inesperado:', error);
    yield put({ type: `${UNSUBSCRIBE_NEWSLETTER}_ERROR`, payload: error.message || 'Error inesperado' });
  }
}

export default function* newsletterSaga() {
  console.log('🚀 [Frontend Saga] newsletterSaga - Watcher iniciado');
  yield takeLatest(UNSUBSCRIBE_NEWSLETTER, unsubscribeNewsletterSaga);
} 